// Names of points for time tracking
export const TRACK_INIT_PAGE_LOAD = 'init-page-load';
export const TRACK_SEARCH_RESULTS_LOAD = 'search-results-load';
export const TRACK_SEARCH_POLL_TIME = 'search-results-poll';
export const TRACK_SEARCH_FIRST_RESULT_TIME = 'search-first-result';
